import * as Types from '../../__generated_types__/types.generated';

import { gql } from '@apollo/client';
export type MagicxPromoCategoryFieldsFragment = { __typename?: 'magicx_promo_collections', id: string, internal_name?: string | null, ordering?: number | null, carousel_type?: string | null, translations?: Array<{ __typename?: 'magicx_promo_collections_translations', display_name?: string | null } | null> | null };

export const MagicxPromoCategoryFieldsFragmentDoc = gql`
    fragment MagicxPromoCategoryFields on magicx_promo_collections {
  id
  internal_name
  ordering
  carousel_type
  translations(
    filter: {languages_language_code: {language_code: {_eq: $language}}}
    limit: 1
  ) {
    display_name
  }
}
    `;